import { SpanContext } from 'opentracing'

export class CustomSpanContext extends SpanContext {
  constructor(private traceId: string, private spanId: string, private parentId: string) {
    super()
  }

  public toTraceId(): string {
    return this.traceId
  }

  public toSpanId(): string {
    return this.spanId
  }

  public toParentId(): string {
    return this.parentId
  }
}
